module.exports = __webpack_public_path__ + "static/img/theme_02.1fea9f81.png";